import { render, staticRenderFns } from "./TransformOrderIntermediary.vue?vue&type=template&id=68e742bf&"
import script from "./TransformOrderIntermediary.vue?vue&type=script&lang=js&"
export * from "./TransformOrderIntermediary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports